export type PanelFreshnessState = "closed" | "stale" | "live";

/** CLOSED is authoritative: a closed venue never degrades to a stale alarm. */
export function panelFreshnessState(
  venueVerdict: string | null | undefined,
  stale: boolean,
): PanelFreshnessState {
  if (venueVerdict === "CLOSED") return "closed";
  return stale ? "stale" : "live";
}
